// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f4399f44","186":"c0ad8dc6","223":"cdafbae0","225":"9980fda7","344":"19c1ba93","372":"d43380b4","377":"b2f0f99d","573":"b30f4792","738":"6efb4177","841":"a55851ab","856":"b6286633","862":"d1a581b1","883":"5252c846"}[chunkId] + ".chunk.js";
};